import React from "react";

import Spinner from "shared/ui/atoms/Spinner/Spinner";

import styles from "./TemplateBlurLoader.module.scss";

const TemplateBlurLoader = ({ text }: { text: string }) => {
  const [isClosed, setIsClosed] = React.useState(false);

  if (isClosed) return null;
  return (
    <div className={styles.container} onDoubleClick={() => setIsClosed(true)}>
      <div className={styles.content}>
        <Spinner isStatic className={styles.spinner} />
        <div className={styles.message}>{text}</div>
      </div>
    </div>
  );
};

export default TemplateBlurLoader;
